// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GraphicVideos: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="39" viewBox="0 0 60 39" fill="currentColor">
            <path
                fill="currentColor"
                d="M1057.75,1995.875 L1057.75,2025.125 C1057.75,2027.81742 1055.56742,2030 1052.875,2030 L1023.625,2030 C1020.93258,2030 1018.75,2027.81742 1018.75,2025.125 L1018.75,1995.875 C1018.75,1993.18258 1020.93258,1991 1023.625,1991 L1052.875,1991 C1055.56641,1991 1057.75,1993.18258 1057.75,1995.875 Z M1077.25,1997.44922 L1077.25,2023.54062 C1077.25,2026.13047 1074.28742,2027.64273 1072.13226,2026.15992 L1061,2018.49297 L1061,2002.50703 L1072.13125,1994.83297 C1074.29453,1993.34914 1077.25,1994.86953 1077.25,1997.44922 Z"
                transform="translate(-1018 -1991)"
            />
        </svg>
    );
};

export default React.memo(GraphicVideos);
